"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// using string accessor fixes error with "Error: Cannot find symbol for node: NODE_ENV"
// eslint-disable-next-line dot-notation
var isProduction = function () { return process.env['NODE_ENV'] === 'production'; };
exports.default = isProduction;
